/**
 * React bindings for the i18n runtime (#799). useT() subscribes the component to language changes (no provider is
 * needed: the state is a module singleton) and returns the translate function. Rich messages: ./Msg.tsx.
 */
import { useSyncExternalStore } from 'react';
import { getState, subscribe, t, type LocaleChoice, type LocaleCode } from './i18n';

const snapshot = () => getState().version;

/** Re-render on language change. Returns t (it reads the active locale at render time). */
export function useT(): typeof t {
  useSyncExternalStore(subscribe, snapshot, snapshot);
  return t;
}

export function useLocale(): { locale: LocaleCode; choice: LocaleChoice } {
  useSyncExternalStore(subscribe, snapshot, snapshot);
  const s = getState();
  return { locale: s.locale, choice: s.choice };
}
